/**
 * Created by Pavel on 14.11.14.
 *
 * Lazy image component
 */
define([
    'jQuery'
    ],
    function($) {
        var defaultAttr = 'data-lazy-img-src',
            LazyLoader = {
                loadImages: function(element, attr) {
                    if (typeof attr === 'undefined') {
                        attr = defaultAttr;
                    }
                    $('img['+attr+']', element).each(function() {
                        var image = $(this);
                        image[0].onload = function() {
                            image.removeAttr('data-lazy-img-src');
                        };
                        image.attr('src', image.attr('data-lazy-img-src'));
                    });
                }
            };

        return LazyLoader;
    }
);


// WEBPACK FOOTER //
// ./src/Allt/FrontendBundle/Resources/assets/components/lazyimage/lazyImage.js